var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 98,
    viewBox: "0 0 96 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#F6F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_85_2297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88 48C88 70.0914 70.0914 88 48 88C25.9086 88 8 70.0914 8 48C8 25.9086 25.9086 8 48 8C70.0914 8 88 25.9086 88 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 8C70.0762 8 88 25.9235 88 48C88 70.0765 70.0765 88 48 88C25.9226 88 8 70.0765 8 48C8 25.9235 25.9235 8 48 8ZM40.3399 65.0625C39.8702 65.5322 39.2343 65.7961 38.5716 65.7961C37.9078 65.7961 37.273 65.5322 36.8033 65.0625C33.3843 61.6446 26.1983 54.4562 26.1983 54.4562C25.2217 53.4809 25.2217 51.8974 26.1983 50.9208C27.1725 49.9443 28.756 49.9443 29.7325 50.9208L38.5715 59.7586L66.2664 32.0637C66.7349 31.5963 67.3709 31.3324 68.0347 31.3324C68.6985 31.3324 69.3333 31.5963 69.8018 32.0637C70.2715 32.5345 70.5342 33.1693 70.5342 33.832C70.5342 34.4958 70.2715 35.1306 69.8018 35.6002C69.8018 35.6002 46.9443 58.458 40.3399 65.0625Z",
    fill: "#27864D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_85_2297",
    x: 2,
    y: 6,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85_2297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_85_2297",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.d042696027d1b82bf805dc3c1ee73ebb.svg";
export { ForwardRef as ReactComponent };